import {
    createRouter,
    createWebHistory,
    RouteLocationNormalized,
    RouteLocationRaw,
} from "vue-router";
// import getEnv from "./env"
// const env = getEnv()

import {
    removeSelectedCompany,
    setSelectedCompanyFromUrl,
    setAccountingFirm,
    // removeAccountingFirm,
} from "./services/routerServices";

import { apolloClient } from "./apollo.services";
import AdminHome from "./views/admin/AdminHome.vue";
import Home from "./views/Home.vue";
import Dashboard from "./views/Dashboard.vue";
import Bank from "./views/Bank.vue";
import DocumentsTable from "./views/document/DocumentsTable.vue";
import Document from "./views/document/DocumentRouter.vue";
import Mail from "./views/mail/Mail.vue";
// import ToBeDone from "./views/ToBeDone.vue";
import AccountingItems from "./views/AccountingItems.vue";
import AccountingItemStatic from "./views/AccountingItemStatic.vue";
import Reconciliation from "./views/Reconciliation.vue";
import Login from "./views/auth/Login.vue";
import Register from "./views/register/Register.vue";
import { store, User } from "./store/store";
import AuthRedirectSSO from "./views/auth/AuthRedirectSSO.vue";
import PasswordRecovery from "./views/auth/PasswordRecovery.vue";
import ResetPassword from "./views/auth/ResetPassword.vue";
import EmailVerification from "./views/auth/EmailVerification.vue";
import Admin from "./views/admin/Admin.vue";
import FirstConnexion from "./views/auth/FirstConnexion.vue";
import AdminCompanyEdition from "./views/admin/CompanyEdition.vue";
import UserEdition from "./views/user/UserEdition.vue";
import AdminCompaniesTable from "./views/admin/Companies.vue";
import ControlCenterIndex from "./views/controlCentre/Index.vue";
import ControlCenterDashboard from "./views/controlCentre/Dashboard.vue";
import ControlCenterAPI from "./views/controlCentre/API.vue";
import Index from "./views/Index.vue";
import ExportAccounting from "./views/ExportAccounting.vue";
import GeneralLedgerPage from "./views/GeneralLedgerPage.vue";
import AccountingLogPage from "./views/accounting/AccountingLogPage.vue";
import AccountingLines from "./views/accounting/AccountingLines.vue";
import VATDeclarationAuto from "./views/taxForm/declaration/VATDeclarationAuto.vue";
import VATDeclarationAssist from "./views/taxForm/declaration/VATDeclarationAssist.vue";
import DasTwo from "./views/taxForm/declaration/DasTwo.vue";
import BudgetInsightCallback from "./views/BudgetInsightCallback.vue";
import Tags from "./views/admin/Tags.vue";
// import AccountableAccounts from "./views/admin/AccountableAccounts.vue";
import CompanyActivitiesTable from "./views/admin/CompanyActivitiesTable.vue";
import CompanyActivityDetails from "./views/admin/CompanyActivityDetails.vue";
import PartitionTags from "./views/tag/PartitionTags.vue";
import PartitionTag from "./views/tag/PartitionTag.vue";
import Budgets from "./views/Budgets.vue";
import UsersActivities from "./views/UsersActivities.vue";
import TicketsZ from "./views/zTillReceipt/TicketZTable.vue";
import ExpenseReports from "./views/expenseReport/ExpenseReports.vue";
import ExpenseReport from "./views/expenseReport/ExpenseReport2.vue";
import InvoiceTable from "./views/invoice/InvoiceTable.vue";
import StockTable from "./views/stock/StockTable.vue";
import InvoiceEdition from "./views/invoice/InvoiceEdition.vue";
import PublicInvoiceView from "./views/invoice/publicView/PublicInvoiceView.vue";
import ProfilesTable from "./views/admin/ProfilesTable.vue";
import Profile from "./views/admin/Profile.vue";
import ImportFEC from "./views/ImportFEC.vue";
// import InvoiceNumberPattern from "./views/admin/InvoiceNumberPattern.vue";
import PageNotFound from "./views/PageNotFound.vue";
import NoAccessPage from "./views/NoAccessPage.vue";
import FacturX from "./views/FacturX.vue";
import AuditStatus from "./views/audit/AuditStatus.vue";
import CheckRecurrentInvoice from "./views/audit/CheckRecurrentInvoice.vue";
import CheckVATGift from "./views/audit/CheckVATGift.vue";
import CheckBilanZTill from "./views/audit/CheckBilanZTill.vue";

import CompanyScopeTable from "./views/admin/CompanyScopeTable.vue";
import CompanyScopeEdition from "./views/admin/CompanyScopeEdition.vue";
import WordingAnalysisTable from "./views/admin/WordingAnalysisTable.vue";
import WordingAnalysisEdition from "./views/admin/WordingAnalysisEdition.vue";
import AccountingPeriodOpening from "./views/AccountingPeriodOpening.vue";

import CheckPurchasesOver500 from "./views/audit/CheckPurchasesOver500.vue";

import AdminManager from "./views/admin/AdminManager.vue";
import CompanyEdition from "./views/admin/CompanyEdition.vue";
import Template from "./views/Template.vue";

import AuditChecks from "./views/admin/AuditChecks.vue";
import CheckBankAccountBalance from "./views/audit/CheckBankAccountBalance.vue";
import CheckDoublonsWithAccountingItemImport from "./views/audit/CheckDoublonsWithAccountingItemImport.vue";

import DashboardAccounting from "./views/dashboardAccounting/DashboardAccounting.vue";

import AccoutantHome from "./views/AccountantHomePage.vue";

import AccountingClientMonitoring from "./views/accountingClients/AccountingClientMonitoring.vue";
import Maintenance from "./views/Maintenance.vue";

import Outstanding from "./views/admin/Outstanding.vue";

import CheckDoubtfullAccounts from "./views/audit/CheckDoubtfullAccounts.vue";
import CheckCreditNotesToIssue from "./views/audit/CheckCreditNotesToIssue.vue";
import CheckProvisionPaidHolidays from "./views/audit/CheckProvisionPaidHolidays.vue";
import CheckSalaryCommon from "./views/audit/CheckSalaryCommon.vue";
import CheckFixedAssetsToDepreciate from "./views/audit/CheckFixedAssetsToDepreciate.vue";
import CheckClosureVAT3 from "./views/audit/CheckClosureVAT3.vue";
import CheckCorporateTax from "./views/audit/CheckCorporateTax.vue";
import DocumentPDF from "./views/document/DocumentPDF.vue";
import CheckReceivablesAgeing from "./views/audit/CheckReceivablesAgeing.vue";
import CheckCapitalChanges from "./views/audit/CheckCapitalChanges.vue";
import AuditReport from "./views/audit/AuditReport.vue";
import CheckReversal from "./views/audit/CheckReversal.vue";
import CheckSuppliersAdjustments from "./views/audit/CheckSuppliersAdjustments.vue";
import CheckCustomersAdjustments from "./views/audit/CheckCustomersAdjustments.vue";
import CheckFixedAssetsCutPrevious from "./views/audit/CheckFixedAssetsCutPrevious.vue";
import CheckBankReconciliation from "./views/audit/CheckBankReconciliation.vue";
import CheckBankLoansAuto from "./views/audit/CheckBankLoansAuto.vue";
import CheckLeasingAuto from "./views/audit/CheckLeasingAuto.vue";

import AuditCheckManual from "./views/audit/AuditCheckManual.vue";
import AccountingReviewLayout from "./views/audit/AccountingReviewLayout.vue";
import AccountingReviewLayoutsTable from "./views/audit/AccountingReviewLayoutsTable.vue";
import AccountingPlanStandardEditor from "./views/admin/AccountingPlanStandardEditor.vue";
import AccountingPlans from "./views/admin/AccountingPlans.vue";

import BookletTemplates from "./views/admin/BookletTemplates.vue";
import BookletTemplate from "./views/admin/BookletTemplate.vue";

import ExportThemes from "./views/admin/ExportThemes.vue";
import ExportThemeEdition from "./views/bookletTemplate/ExportThemeEdition.vue";

import ExportOfficeTable from "./views/admin/ExportOfficeTable.vue";
import ExportOfficeSheet from "./views/admin/ExportOfficeSheet.vue";

// import ComputedIndicatorSelector from "./views/computedIndicator/ComputedIndicatorSelector.vue";
import computedIndicatorTable from "./views/admin/ComputedIndicatorTable.vue";

import OperatingAccountSheet from "./views/admin/OperatingAccountSheet.vue";
import OperatingAccountTable from "./views/admin/OperatingAccountTable.vue";
import CashFlowPlan from "./views/dashboard/CashFlowPlan.vue";

import ConfigAPIPage from "./views/admin/ConfigAPIPage.vue";

import EngagementLetter from "./views/engagementLetter/EngagementLetter.vue";
import EngagementLetters from "./views/engagementLetter/EngagementLetters.vue";

import OpenPoints from "./views/dashboardAccounting/OpenPoints.vue";
import ImportEBICS from "./views/admin/ImportEBICS.vue";

import MainBilling from "./views/admin/billing/MainBilling.vue";
import BobbeeClients from "./views/admin/billing/BobbeeClients.vue";

import Declaration from "./views/taxForm/declaration/Declaration.vue";

import UPDATE_USER from "./graphql/user/UpdateUser.gql";
import LOGGED_IN_USER from "./graphql/auth/LoggedInUser.gql";

import { setCurrentCompany, updateStoreUserAndSubUser } from "./services/userServices";

import Tasks from "./views/tasks/Tasks.vue";

import BudgetFormAccountableAccount from "./views/budgetForm/BudgetFormAccountableAccount.vue";

import DocumentRuleSheet from "./views/admin/DocumentRuleSheet.vue";
import DocumentRuleTable from "./views/admin/DocumentRuleTable.vue";

import BundleManager from "./views/taxForm/bundle/BundleManager.vue";
import DeclarationManager from "./views/taxForm/declaration/DeclarationManager.vue";
import TaxFormReadOnly from "./views/taxForm/TaxFormReadOnly.vue";
import ChatCompany from "./views/chat/ChatCompany.vue";

import TaxFormDisplayPlayground from "./views/taxForm/playground/TaxFormDisplayPlayground.vue";

import LoadingPage from "./views/LoadingPage.vue";

import CompanyCluster from "./views/CompanyCluster.vue";

import TaxFormList from "./views/taxForm/TaxFormList.vue";
import DeclarationForm from "./views/taxForm/declaration/DeclarationForm.vue";

import ExtensionsTable from "./views/extension/ExtensionsTable.vue";

import AccountingClients from "./views/accountingClients/AccountingClients.vue";
// import getEnv from "./env";
import { AuthServices } from "./services/auth.services";

import DocumentLoan from "./views/document/DocumentLoan.vue";
import DocumentLeasing from "./views/document/DocumentLeasing.vue";
import CompanyStatusBoard from "./views/CompanyStatusBoard.vue";

import TutorialsProgress from "./views/tutorial/TutorialsProgress.vue";
import DesignerPage from "./views/designer/DesignerPage.vue";
import { checkOfferPermission, checkProfilePermission } from "./services/router.services";

// const env = getEnv();

const PUBLICS_PAGES = [
    "/maintenance",
    "/login",
    "/register",
    "/public",
    "/password-recovery",
    "/auth-google-consent",
    "/first-connexion",
    "/tax-forms/playground",
];

export class Start {
    private static start: Start = null;
    started: boolean = false;
    loginStarted: boolean = false;
    to: RouteLocationNormalized;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    loggedInUser: any;
    constructor(to: RouteLocationNormalized) {
        this.to = to;
    }

    redirectIfNotFound() {
        console.log("redirectIfNotFound");
        // this.loggedInUser = null;
        // this.started = true;
        // debugger;
        if (this.to.fullPath.startsWith("/redirect-sso")) {
            return router.resolve({ name: this.loggedInUser?.profile?.homePage });
            // {name: this.loggedInUser?.profile?.homePage}
        } else {
            console.log("redirectIfNotFound", this.to);
            return this.to;
        }
    }

    async login() {
        if (this.started) {
            //debugger;
            return this.redirectIfNotFound();
        }
        this.loginStarted = true;

        try {
            console.log("router - start login");
            const token = await AuthServices.getUserToken();
            // debugger
            if (!token) {
                // this.to = router.resolve({ name: "login", query: { from: this.to.fullPath } });
                // console.log("token null");
                return this.redirectIfNotFound();
            }
            // console.log("token", token)
            const res = await apolloClient.query({
                query: LOGGED_IN_USER,
                fetchPolicy: "network-only",
            });
            // debugger
            this.loggedInUser = res?.data?.loggedInUser || null;
            // console.log("loggedInUser= ", this.loggedInUser?.id || null);
            this.started = true;
            return this.redirectIfNotFound();
            // if (this.to.fullPath.startsWith('/redirect-sso')) {
            // const profileLoggedRootName = this.loggedInUser?.profile?.homePage;
            // return profileLoggedRootName;
            // } else {
            //     router.replace(this.to)
            // }
        } catch (e) {
            //debugger;
            console.error(e);
            return this.redirectIfNotFound();
        }
    }

    setLoggedInUser(loggedInUser) {
        this.loggedInUser = loggedInUser;
        this.started = !!this.loggedInUser;
    }

    static getCreateStart(to: RouteLocationNormalized = undefined) {
        if (!Start.start) {
            Start.start = new Start(to);
        }
        return Start.start;
    }
}

export const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: "/", name: "home", component: Home },
        { path: "/login", name: "login", component: Login },
        // { path: "/register", name: "register", component: env.DEV_MODE ? Register : PageNotFound },
        { path: "/register", name: "register", component: Register },
        {
            path: "/public/invoice/:mailId",
            name: "publicInvoiceView",
            component: PublicInvoiceView,
            props: true,
        },
        // { path: '/login2', name: 'login2', component:  },
        // { path: '/signup', name: 'signup', component: CreateAccountLight },
        {
            path: "/first-connexion/:email",
            name: "first-connexion",
            component: FirstConnexion,
            props: true,
        },
        { path: "/redirect-sso", name: "redirectSSO", component: AuthRedirectSSO },
        // { path: '/signup', name: 'signup', component: CreateAccountLight },
        { path: "/password-recovery", name: "password-recovery", component: PasswordRecovery },
        { path: "/password-recovery/:token", name: "password-reset", component: ResetPassword },
        {
            path: "/email-verification/:token",
            name: "email-verification",
            component: EmailVerification,
        },
        { path: "/accountant-home", name: "accountant-home", component: AccoutantHome },
        { path: "/maintenance", name: "maintenance", component: Maintenance },
        { path: "/loading", name: "loading-page", component: LoadingPage },
        {
            path: "/tax-forms/playground",
            name: "tax-form-playground",
            component: TaxFormDisplayPlayground,
        },

        {
            path: "/admin",
            name: "admin",
            component: Admin,
            beforeEnter: (from, to, next) => {
                removeSelectedCompany();

                const checkPerm = checkProfilePermission("internalManagement.access");
                checkPerm(from, to, next);
            },
            children: [
                { path: "/", name: "adminHome", component: AdminHome },
                {
                    path: "companies",
                    name: "companies-table",
                    component: AdminCompaniesTable,
                },
                // { path: 'users', name: 'users-table', component: UserTable },
                {
                    path: "edition/:id",
                    name: "compa",
                    component: CompanyEdition,
                    props: true,
                    beforeEnter: (from, to, next) => {
                        const selectedCompanyFromUrl = setSelectedCompanyFromUrl(
                            to.params.id as string,
                        );

                        if (selectedCompanyFromUrl) {
                            next();
                        } else {
                            next(false);
                        }
                    },
                },
                {
                    path: "companies/me/:type",
                    name: "my-companies-edition",
                    component: AdminManager,
                    props: true,
                    beforeEnter: checkProfilePermission("company.read"),
                },
                {
                    path: "companies/:id/:type",
                    name: "companies-edition",
                    component: AdminManager,
                    props: true,
                    beforeEnter: (from, to, next) => {
                        const selectedCompanyFromUrl = setSelectedCompanyFromUrl(
                            to.params.id as string,
                        );

                        if (selectedCompanyFromUrl) {
                            next();
                        } else {
                            next(false);
                        }
                    },
                },
                { path: "companies/new", name: "create-company", component: AdminCompanyEdition },
                {
                    path: ":companyId/users/new",
                    name: "create-user",
                    component: UserEdition,
                    beforeEnter: (from, to, next) => {
                        const selectedCompanyFromUrl = setSelectedCompanyFromUrl(
                            to.params.companyId as string,
                        );

                        if (selectedCompanyFromUrl) {
                            next();
                        } else {
                            next(false);
                        }
                    },
                },
                {
                    path: "users/:id",
                    name: "admin-users-details",
                    component: UserEdition,
                    props: true,
                },
                {
                    path: "tax-forms",
                    name: "adminTaxForm",
                    component: TaxFormList,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("declaration.read"),
                        checkOfferPermission("isAllowedToTaxDeclaration"),
                    ],
                },
                {
                    path: "tags",
                    name: "tags",
                    component: Tags,
                    beforeEnter: checkProfilePermission("tag.read"),
                },
                // {
                //     path: "tags/accountable-account",
                //     name: "accountableaccount-table",
                //     component: AccountableAccounts,
                // },
                {
                    path: "company-activities",
                    name: "companyactivities-table",
                    component: CompanyActivitiesTable,
                },
                {
                    path: "company-activities/:id",
                    name: "companyactivity-details",
                    component: CompanyActivityDetails,
                    props: true,
                },
                {
                    path: "partitions-tags",
                    name: "partitionstags-table",
                    component: PartitionTags,
                },
                {
                    path: "partitions-tags/:id",
                    name: "partitionstags-edition",
                    component: PartitionTag,
                    props: true,
                },
                {
                    path: "partitions-tags/new",
                    name: "partitionstags-new",
                    component: PartitionTag,
                },
                {
                    path: "profiles",
                    name: "profiles-table",
                    component: ProfilesTable,
                    beforeEnter: checkProfilePermission("profile.read"),
                },
                {
                    path: "profile/new",
                    name: "profile-new",
                    component: Profile,
                    props: true,
                    beforeEnter: checkProfilePermission("profile.write"),
                },
                {
                    path: "profile/:profileId",
                    name: "profile-edition",
                    component: Profile,
                    props: true,
                    beforeEnter: checkProfilePermission("profile.read"),
                },
                // {
                //     path: "invoice-number-pattern",
                //     name: "invoice-number-pattern-table",
                //     component: InvoiceNumberPattern,
                // },
                // {
                //     path: "companies-patterns",
                //     name: "companies-patterns-table",
                //     component: CompaniesInvoiceNumberPatterns,
                // },
                {
                    path: "AccountingReviewLayoutsTable",
                    name: "AccountingReviewLayoutsTable",
                    component: AccountingReviewLayoutsTable,
                },
                {
                    path: "AccountingReviewLayout/new",
                    name: "AccountingReviewLayout-new",
                    component: AccountingReviewLayout,
                },
                {
                    path: "AccountingReviewLayout/new/:idToDuplicate",
                    name: "AccountingReviewLayout-new-duplicate",
                    component: AccountingReviewLayout,
                    props: true,
                },
                {
                    path: "AccountingReviewLayout/:id",
                    name: "AccountingReviewLayout",
                    component: AccountingReviewLayout,
                    props: true,
                },
                {
                    path: "auditChecks/:mode",
                    name: "auditChecks",
                    component: AuditChecks,
                    props: true,
                    beforeEnter: checkProfilePermission("internalManagement.access"),
                },
                { path: "activity", name: "users-activities", component: UsersActivities },
                {
                    path: "activity/tutorials",
                    name: "tutorials-activities",
                    component: TutorialsProgress,
                },
                {
                    path: "company-scopes",
                    name: "company-scopes",
                    component: CompanyScopeTable,
                },
                {
                    path: "wording-analysis",
                    name: "wording-analysis",
                    component: WordingAnalysisTable,
                },
                {
                    path: "booklet-templates",
                    name: "booklet-templates",
                    component: BookletTemplates,
                },
                {
                    path: "booklet-template/new",
                    name: "new-booklet-template",
                    component: BookletTemplate,
                },
                {
                    path: "booklet-template/newFrom/:idToDuplicate",
                    name: "new-from-booklet-template",
                    component: BookletTemplate,
                    props: true,
                },
                {
                    path: "booklet-template/:idTemplate",
                    name: "booklet-template",
                    component: BookletTemplate,
                    props: true,
                },
                { path: "export-themes", name: "export-themes", component: ExportThemes },
                {
                    path: "export-theme-edition/new",
                    name: "export-theme-edition-new",
                    component: ExportThemeEdition,
                },
                {
                    path: "export-theme-edition/new/:idToDuplicate",
                    name: "export-theme-edition-new-duplicate",
                    component: ExportThemeEdition,
                    props: true,
                },
                {
                    path: "export-theme-edition/:id",
                    name: "export-theme-edition",
                    component: ExportThemeEdition,
                    props: true,
                },
                {
                    path: "company-scope-edition",
                    name: "company-scope-edition-new",
                    component: CompanyScopeEdition,
                    props: true,
                },
                {
                    path: "company-scope-edition/:id",
                    name: "company-scope-edition",
                    component: CompanyScopeEdition,
                    props: true,
                },
                {
                    path: "wording-analysis-edition",
                    name: "wording-analysis-edition-new",
                    component: WordingAnalysisEdition,
                    props: true,
                },
                {
                    path: "wording-analysis-edition/:id",
                    name: "wording-analysis-edition",
                    component: WordingAnalysisEdition,
                    props: true,
                },
                {
                    path: "audit/monitoring",
                    name: "auditMonitoring",
                    component: AccountingClientMonitoring,
                    props: true,
                },
                {
                    path: "engagement-letter",
                    name: "new-engagement-letter",
                    component: EngagementLetter,
                    beforeEnter: (from, to, next) => {
                        const selectedAccountingFirm = setAccountingFirm();

                        if (selectedAccountingFirm) {
                            next();
                        } else {
                            next(false);
                        }
                    },
                },
                {
                    path: "engagement-letter/:id",
                    name: "engagement-letter",
                    component: EngagementLetter,
                    props: true,
                    beforeEnter: checkProfilePermission("engagementLetter.read"),
                },
                {
                    path: "engagement-letters",
                    name: "engagement-letters",
                    component: EngagementLetters,
                    beforeEnter: checkProfilePermission("engagementLetter.read"),
                },
                {
                    path: ":companyId/configuration",
                    name: "configuration",
                    component: ConfigAPIPage,
                    props: true,
                    beforeEnter: (from, to, next) => {
                        const selectedAccountingFirm = setAccountingFirm();

                        if (selectedAccountingFirm) {
                            next();
                        } else {
                            next(false);
                        }
                    },
                },
                { path: "import-ebics", name: "import-ebics", component: ImportEBICS },
                { path: "export-office", name: "export-office", component: ExportOfficeTable },
                {
                    path: "export-office-sheet/new/:format",
                    name: "new-export-office-sheet",
                    component: ExportOfficeSheet,
                    props: true,
                },
                {
                    path: "export-office-sheet/:id",
                    name: "export-office-sheet",
                    component: ExportOfficeSheet,
                    props: true,
                },
                { path: "billing-bobbee", name: "billing-bobbee", component: MainBilling },
                { path: "bobbee-clients", name: "bobbee-clients", component: BobbeeClients },
                {
                    path: "computedIndicatorTable",
                    name: "computedIndicatorTable",
                    component: computedIndicatorTable,
                },
                {
                    path: "operatingAccountTable",
                    name: "operatingAccountTable",
                    component: OperatingAccountTable,
                },
                {
                    path: "operatingAccountSheet/new",
                    name: "new-operatingAccountSheet",
                    component: OperatingAccountSheet,
                },
                {
                    path: "operatingAccountSheet/:idSheet",
                    name: "operatingAccountSheet",
                    component: OperatingAccountSheet,
                    props: true,
                },
                {
                    path: "tasks",
                    name: "admintasks",
                    component: Tasks,
                    props: true,
                    beforeEnter: checkProfilePermission("task.read"),
                },
                {
                    path: "document-rule",
                    name: "document-rule",
                    component: DocumentRuleTable,
                    props: true,
                },
                {
                    path: "document-rule-sheet/new",
                    name: "new-document-rule-sheet",
                    component: DocumentRuleSheet,
                    props: true,
                },
                {
                    path: "document-rule-sheet/:id",
                    name: "document-rule-sheet",
                    component: DocumentRuleSheet,
                    props: true,
                },
                {
                    path: "accounting-plans",
                    name: "accounting-plans",
                    component: AccountingPlans,
                    props: true,
                },
                {
                    path: "accounting-plan/new",
                    name: "new-accounting-plan",
                    component: AccountingPlanStandardEditor,
                },
                {
                    path: "accounting-plan/newFrom/:idToDuplicate",
                    name: "new-from-accounting-plan",
                    component: AccountingPlanStandardEditor,
                    props: true,
                },
                {
                    path: "accounting-plan/:id",
                    name: "accounting-plan",
                    component: AccountingPlanStandardEditor,
                    props: true,
                },
                { path: "companyCluster", name: "companyCluster", component: CompanyCluster },
                // { path: 'activityNew', name: "users-activities-new", component: UsersActivitiesNew },
                { path: "extensions", name: "extensions", component: ExtensionsTable },
            ],
        },
        {
            path: "/control-center",
            component: ControlCenterIndex,
            redirect: { name: "controlCenterDashboard" },
            children: [
                {
                    path: "dashboard",
                    name: "controlCenterDashboard",
                    component: ControlCenterDashboard,
                    props: true,
                    beforeEnter: checkProfilePermission("controlCenter.write"),
                },
                {
                    path: "api",
                    name: "controlCenterAPI",
                    component: ControlCenterAPI,
                    props: true,
                    beforeEnter: checkProfilePermission("controlCenter.write"),
                },
            ],
        },
        {
            path: "/",
            component: Index,
            // redirect: { name: "dashboard" },
            children: [
                // { path: '/', name: 'home', component: Home },
                { path: "template", name: "template", component: Template },
                { path: "designer", name: "designer", component: DesignerPage },
                { path: "statusBoard", name: "companyStatusBoard", component: CompanyStatusBoard },
                {
                    path: "bank",
                    name: "bank",
                    component: Bank,
                    props: (route) => {
                        const query = route.query;
                        return {
                            ...query,
                        };
                    },
                    beforeEnter: checkProfilePermission("bankTransaction.read"),
                },
                {
                    path: "bank/reconciliationStatus/:reconciliationStatus",
                    name: "bankSpecificStatus",
                    component: Bank,
                    beforeEnter: checkProfilePermission("bankTransaction.read"),
                },
                {
                    path: "bank/tag/:tagId",
                    name: "bank-tag",
                    component: Bank,
                    beforeEnter: checkProfilePermission("bankTransaction.read"),
                },
                {
                    path: "dashboard",
                    name: "dashboard",
                    component: Dashboard,
                    beforeEnter: checkProfilePermission("business.dashboard"),
                },
                { path: "cashFlowPlan", name: "cashFlowPlan", component: CashFlowPlan },
                {
                    path: "documents",
                    name: "documents",
                    component: DocumentsTable,
                    props: (route) => {
                        const query = route.query;

                        return {
                            ...query,
                        };
                    },
                    beforeEnter: checkProfilePermission("document.read"),
                },
                { path: "documents/tag/:tagId", name: "documents-tag", component: DocumentsTable },
                {
                    path: "documents/orderBy/:orderBy",
                    name: "documentsOrderBy",
                    component: DocumentsTable,
                    beforeEnter: checkProfilePermission("document.read"),
                },
                {
                    path: ":companyId/documents/:id",
                    name: "document",
                    component: Document,
                    props: true,
                    beforeEnter: checkProfilePermission("document.read"),
                },
                { path: ":companyId/mail/:id", name: "mail", component: Mail, props: true },
                { path: "accountingItems", name: "accountingItems", component: AccountingItems },
                {
                    path: ":companyId/accountingItems/document/:documentId",
                    name: "accountingItemDocument",
                    component: AccountingItemStatic,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("document.read"),
                        // checkOfferPermission("isAllowedToExpenseReport"),
                    ],
                },
                {
                    path: ":companyId/accountingItems/zTillReceipt/:zTillReceiptId",
                    name: "accountingItemZTillReceipt",
                    component: AccountingItemStatic,
                    props: true,
                },
                {
                    path: ":companyId/accountingItems/expenseReport/:expenseReportId",
                    name: "accountingItemExpenseReport",
                    component: AccountingItemStatic,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("expenseReport.read"),
                        checkOfferPermission("isAllowedToExpenseReport"),
                    ],
                },
                { path: "users/:id", name: "users-details", component: UserEdition, props: true },
                { path: "zTillReceipts", name: "ztillReceipts", component: TicketsZ },
                {
                    path: ":companyId/import/:documentType/:mode",
                    name: "importFec",
                    component: ImportFEC,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("accounting.import"),
                        checkOfferPermission("isAllowedToAccounting"),
                    ],
                },
                {
                    path: ":companyId/import/:documentType/edition/:id",
                    name: "importFecEdition",
                    component: ImportFEC,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("accounting.import"),
                        checkOfferPermission("isAllowedToAccounting"),
                    ],
                },
                {
                    path: ":companyId/import/:documentType/edition/:id/repair/:repair",
                    name: "importFecRepair",
                    component: ImportFEC,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("accounting.import"),
                        checkOfferPermission("isAllowedToAccounting"),
                    ],
                },
                {
                    path: "companies/:companyId",
                    name: "companyEdition",
                    component: AdminCompanyEdition,
                    beforeEnter: checkProfilePermission("company.read"),
                },
                {
                    path: "dashboardAccounting",
                    name: "dashboardAccounting",
                    component: DashboardAccounting,
                    beforeEnter: [
                        checkProfilePermission("accounting.dashboard"),
                        checkOfferPermission("isAllowedToAccounting"),
                    ],
                },
                {
                    path: "companies/:companyId/tab/:activeTab",
                    name: "companyEditionTab",
                    component: AdminCompanyEdition,
                },
                {
                    path: ":companyId/reconciliation/bankTransaction/:bankTransactionId",
                    name: "reconciliation/bankTransaction",
                    component: Reconciliation,
                    props: true,
                },
                {
                    path: ":companyId/reconciliation/document/:documentId",
                    name: "reconciliation/document",
                    component: Reconciliation,
                    props: true,
                },
                {
                    path: ":companyId/reconciliation/accountingLine/:accountingLineId",
                    name: "reconciliation/accountingLine",
                    component: Reconciliation,
                    props: true,
                },
                {
                    path: ":companyId/reconciliation/:reconciliationId",
                    name: "reconciliation",
                    component: Reconciliation,
                    props: true,
                },
                {
                    path: "generalLedger",
                    name: "generalLedger",
                    component: GeneralLedgerPage,
                    beforeEnter: [
                        checkProfilePermission("accounting.generalLedger"),
                        checkOfferPermission("isAllowedToAccounting"),
                    ],
                },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/fixed-assets/:acKey/:documentId?/:bankTransactionId?/:accountingLineId?",
                    name: "fixedAssets",
                    component: CheckFixedAssetsToDepreciate,
                    props: true,
                },
                {
                    path: "accountingLog",
                    name: "accountingLog",
                    component: AccountingLogPage,
                    beforeEnter: [
                        checkProfilePermission("accounting.log"),
                        checkOfferPermission("isAllowedToAccounting"),
                    ],
                },
                {
                    path: "accountingLines",
                    name: "accountingLines",
                    component: AccountingLines,
                    beforeEnter: [
                        checkProfilePermission("accounting.accountingLine"),
                        checkOfferPermission("isAllowedToAccounting"),
                    ],
                },
                {
                    path: "exportAccounting",
                    name: "exportAccounting",
                    component: ExportAccounting,
                    beforeEnter: [
                        checkProfilePermission("accounting.export"),
                        checkOfferPermission("isAllowedToAccounting"),
                    ],
                },
                // { path: "vatDeclarations", name: "vatDeclarations", component: VATDeclarations },
                {
                    path: ":companyId/vatDeclarations/auto/:cerfaNumber/:declarationId?/:version/:startDate/:endDate",
                    name: "vatDeclarationAuto",
                    component: VATDeclarationAuto,
                    props: true,
                    beforeEnter: checkProfilePermission("declaration.read"),
                },
                {
                    path: ":companyId/vatCalculationAssist/:cerfaNumber/:declarationId?/:version/:startDate/:endDate",
                    name: "vatCalculationAssist",
                    component: VATDeclarationAssist,
                    props: true,
                    beforeEnter: checkProfilePermission("declaration.read"),
                },
                {
                    path: ":companyId/:cerfaNumber/:startDate/:endDate",
                    name: "dasTwo",
                    component: DasTwo,
                    props: true,
                },
                {
                    path: "bank/sync",
                    name: "budgetInsightCallback",
                    component: BudgetInsightCallback,
                },
                {
                    path: "budgets",
                    name: "budgets",
                    component: Budgets,
                    beforeEnter: [
                        checkProfilePermission("budget.read"),
                        checkOfferPermission("isAllowedToBudget"),
                    ],
                },
                {
                    path: ":companyId/auditCheckExpenseReports/:auditCheckKey",
                    name: "auditCheckExpenseReports",
                    component: ExpenseReports,
                    beforeEnter: [
                        checkProfilePermission("expenseReport.read"),
                        checkOfferPermission("isAllowedToExpenseReport"),
                    ],
                },
                {
                    path: "expenseReports",
                    name: "expenseReports",
                    component: ExpenseReports,
                    beforeEnter: [
                        checkProfilePermission("expenseReport.read"),
                        checkOfferPermission("isAllowedToExpenseReport"),
                    ],
                },
                {
                    path: ":companyId/expenseReports/:id",
                    name: "expenseReport",
                    component: ExpenseReport,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("expenseReport.read"),
                        checkOfferPermission("isAllowedToExpenseReport"),
                    ],
                },
                {
                    path: ":companyId/expenseReports/new",
                    name: "expenseReportNew",
                    component: ExpenseReport,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("expenseReport.write"),
                        checkOfferPermission("isAllowedToExpenseReport"),
                    ],
                },
                {
                    path: "invoices",
                    name: "invoices",
                    component: InvoiceTable,
                    beforeEnter: [
                        checkProfilePermission("salesInvoice.read"),
                        checkOfferPermission("isAllowedToInvoice"),
                    ],
                },
                {
                    path: "stocks",
                    name: "stocks",
                    component: StockTable,
                    beforeEnter: [
                        checkProfilePermission("stock.read"),
                        checkOfferPermission("isAllowedToStock"),
                    ],
                },
                {
                    path: ":companyId/invoices/new",
                    name: "invoiceNew",
                    component: InvoiceEdition,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("salesInvoice.write"),
                        checkOfferPermission("isAllowedToInvoice"),
                    ],
                },
                {
                    path: ":companyId/invoices/:id",
                    name: "invoiceEdition",
                    component: InvoiceEdition,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("salesInvoice.read"),
                        checkOfferPermission("isAllowedToInvoice"),
                    ],
                },
                {
                    path: ":companyId/invoicesMatrix/new",
                    name: "invoiceMatrixNew",
                    component: InvoiceEdition,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("salesInvoice.write"),
                        checkOfferPermission("isAllowedToInvoice"),
                    ],
                },
                {
                    path: ":companyId/quotations/new",
                    name: "quotationNew",
                    component: InvoiceEdition,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("salesInvoice.write"),
                        checkOfferPermission("isAllowedToInvoice"),
                    ],
                },
                {
                    path: ":companyId/quotations/:id",
                    name: "quotationEdition",
                    component: InvoiceEdition,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("salesInvoice.read"),
                        checkOfferPermission("isAllowedToInvoice"),
                    ],
                },
                {
                    path: ":companyId/bill-delivery/new",
                    name: "billDeliveryNew",
                    component: InvoiceEdition,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("salesInvoice.write"),
                        checkOfferPermission("isAllowedToInvoice"),
                    ],
                },
                {
                    path: ":companyId/bill-delivery/:id",
                    name: "billDeliveryEdition",
                    component: InvoiceEdition,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("salesInvoice.read"),
                        checkOfferPermission("isAllowedToInvoice"),
                    ],
                },
                {
                    path: ":companyId/invoiceRecurrence/new",
                    name: "invoiceRecurrenceNew",
                    component: InvoiceEdition,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("salesInvoice.write"),
                        checkOfferPermission("isAllowedToInvoice"),
                    ],
                },
                {
                    path: ":companyId/invoiceRecurrence/:id",
                    name: "invoiceRecurrenceEdition",
                    component: InvoiceEdition,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("salesInvoice.read"),
                        checkOfferPermission("isAllowedToInvoice"),
                    ],
                },
                { path: "audit", name: "auditStatus", component: AuditStatus },
                // { path: 'chat', name: 'chat-manager', component: ChatManager },
                // audit
                {
                    path: ":companyId/checkRecurrentInvoice",
                    name: "checkRecurrentInvoice",
                    component: CheckRecurrentInvoice,
                    props: true,
                },
                {
                    path: "audit/gift/:auditCheck",
                    name: "checkVATGift",
                    component: CheckVATGift,
                    props: true,
                },
                {
                    path: "auditCheckBilanZTill/:auditCheckKey",
                    name: "auditCheckBilanZTill",
                    component: CheckBilanZTill,
                    props: true,
                },
                // { path: 'checkInvoiceNumbers', name: "checkInvoiceNumbers", component: CheckInvoiceNumbers, props: true },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/purchases-over-500/:acKey",
                    name: "purchases-over-500",
                    component: CheckPurchasesOver500,
                    props: true,
                },
                // { path: ':companyId/accountingPeriods/:accountingPeriodId/used-accountable-accounts', name: 'used-accountable-accounts', component: CheckUsedAccountableAccounts, props: true },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/doubtfull-accounts/:acKey",
                    name: "doubtfull-accounts",
                    component: CheckDoubtfullAccounts,
                    props: true,
                },
                {
                    path: ":companyId/checkBankAccountBalance/",
                    name: "checkBankAccountBalance",
                    component: CheckBankAccountBalance,
                    props: true,
                },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/credit-notes-to-issue/:acKey",
                    name: "credit-notes-to-issue",
                    component: CheckCreditNotesToIssue,
                    props: true,
                },
                // { path: 'import-stripe', name: 'importStripe', component: ImportStripe }
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/provision-paid-holidays/:acKey",
                    name: "provision-paid-holidays",
                    component: CheckProvisionPaidHolidays,
                    props: true,
                },
                // { path: ':companyId/accountingPeriods/:accountingPeriodId/provision-employee-manager/:acKey', name: 'provision-employee-manager', component: CheckProvisionEmployeeManager, props: true },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/salary-common/:acKey",
                    name: "salary-common",
                    component: CheckSalaryCommon,
                    props: true,
                },
                {
                    path: "accountingPeriodOpening",
                    name: "accountingPeriodOpening",
                    component: AccountingPeriodOpening,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("accountingPeriod.write"),
                        checkOfferPermission("isAllowedToAccounting"),
                    ],
                },
                {
                    path: "audit/checkDoublonsWithAccountingItemImport",
                    name: "checkDoublonsWithAccountingItemImport",
                    component: CheckDoublonsWithAccountingItemImport,
                },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/closure-vat3/:acKey",
                    name: "closure-vat2",
                    component: CheckClosureVAT3,
                    props: true,
                },
                // ** accountingPeriodId not necessary in path, but used for mounted in code

                // { path: ':companyId/accountingPeriods/:accountingPeriodId/fixed-assets-to-depreciate', name: 'fixed-assets-to-depreciate', component: CheckFixedAssetsToDepreciate, props: true },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/fixed-assets-to-depreciate/:acKey/:documentId?/:bankTransactionId?/:accountingLineId?",
                    name: "fixed-assets-to-depreciate",
                    component: CheckFixedAssetsToDepreciate,
                    props: true,
                },

                // { path: ':companyId/accountingPeriods/:accountingPeriodId/fixed-assets-to-depreciate', name: 'fixed-assets-to-depreciate', component: CheckFixedAssetsToDepreciate, props: true },

                // { path: ':companyId/accountingPeriods/:accountingPeriodId/employer-contributions-rate', name: 'employer-contributions-rate', component: CheckEmployerContributionsRate, props: true },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/corporate-tax/:acKey",
                    name: "corporate-tax",
                    component: CheckCorporateTax,
                    props: true,
                },
                { path: "pdf", name: "pdf", component: DocumentPDF, props: true },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/receivables-ageing/:acKey",
                    name: "receivables-ageing",
                    component: CheckReceivablesAgeing,
                    props: true,
                },
                // { path: ':companyId/accountingPeriods/:accountingPeriodId/capital-changes', name: 'capital-changes', component: CheckCapitalChanges, props: true },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/capital-changes/:acKey",
                    name: "capital-changes",
                    component: CheckCapitalChanges,
                    props: true,
                },
                {
                    path: "openPoints",
                    name: "openPoints",
                    component: OpenPoints,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission(["outstanding.read"]),
                        checkOfferPermission("isAllowedToOpenPoint"),
                    ],
                },
                {
                    path: "opentPoints/:mode",
                    name: "outstandingUser",
                    component: OpenPoints,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission(["outstanding.read"]),
                        checkOfferPermission("isAllowedToOpenPoint"),
                    ],
                },
                {
                    path: "outstanding/:mode",
                    name: "outstandingTPC",
                    component: Outstanding,
                    props: true,
                    beforeEnter: checkProfilePermission(["outstanding.read"]),
                },
                { path: "openPoints/tab/:activeTab", name: "openPointsTab", component: OpenPoints },
                {
                    path: "openPoints/tab/:activeTab/company/:companyName",
                    name: "openPointsTabAndCompany",
                    component: OpenPoints,
                },
                {
                    path: "auditReport",
                    name: "auditReport",
                    component: AuditReport,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("auditReport.read"),
                        checkOfferPermission("isAllowedToAuditReport"),
                    ],
                },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/reversal/:acKey",
                    name: "reversal",
                    component: CheckReversal,
                    props: true,
                },
                {
                    path: "budget-form-accountable-account/new",
                    name: "budget-form-accountable-account-new",
                    component: BudgetFormAccountableAccount,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("budget.write"),
                        checkOfferPermission("isAllowedToBudget"),
                    ],
                },
                {
                    path: "budget-form-accountable-account/:id",
                    name: "budget-form-accountable-account",
                    component: BudgetFormAccountableAccount,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("budget.read"),
                        checkOfferPermission("isAllowedToBudget"),
                    ],
                },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/suppliers-adjustments/:acKey",
                    name: "suppliers-adjustments",
                    component: CheckSuppliersAdjustments,
                    props: true,
                },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/customers-adjustments/:acKey",
                    name: "customers-adjustments",
                    component: CheckCustomersAdjustments,
                    props: true,
                },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/previous-fixed-assets-to-cut/:acKey",
                    name: "previous-fixed-assets-to-cut",
                    component: CheckFixedAssetsCutPrevious,
                    props: true,
                },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/bank-reconciliation/:acKey",
                    name: "bank-reconciliation",
                    component: CheckBankReconciliation,
                    props: true,
                },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/bank-loans/:acKey",
                    name: "bank-loans",
                    component: CheckBankLoansAuto,
                    props: true,
                },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/leasing-audit/:acKey",
                    name: "leasing-audit",
                    component: CheckLeasingAuto,
                    props: true,
                },
                { path: "facturx", name: "facturx", component: FacturX, props: true },
                {
                    path: "tax-forms",
                    name: "taxForms",
                    component: TaxFormList,
                    beforeEnter: [
                        checkProfilePermission("declaration.read"),
                        checkOfferPermission("isAllowedToTaxDeclaration"),
                    ],
                },
                {
                    path: "tax-forms/tab/:selectedWindow",
                    name: "taxFormsTab",
                    component: TaxFormList,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("declaration.read"),
                        checkOfferPermission("isAllowedToTaxDeclaration"),
                    ],
                },
                {
                    path: ":companyId/accountingPeriods/:accountingPeriodId/manual-audit/:acKey",
                    name: "manual-audit",
                    component: AuditCheckManual,
                    props: true,
                },
                { path: "bundle/new", name: "taxForm2-new", component: BundleManager, props: true },
                { path: "bundle/:id", name: "taxForm2", component: BundleManager, props: true },
                {
                    path: "declaration/new/:cerfaNumber/:propsStartDate/:propsEndDate/:accountingPeriodId",
                    name: "declaration-new",
                    component: DeclarationForm,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("declaration.write"),
                        checkOfferPermission("isAllowedToTaxDeclaration"),
                    ],
                },
                {
                    path: "declaration/test/:formTest",
                    name: "declaration-test",
                    component: DeclarationForm,
                    props: true,
                },
                {
                    path: "declaration/:decId",
                    name: "declaration",
                    component: Declaration,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("declaration.read"),
                        checkOfferPermission("isAllowedToTaxDeclaration"),
                    ],
                },
                {
                    path: "declaration2/new/:propsCerfaNumber/:propsStartDate/:propsEndDate",
                    name: "declaration2-new",
                    component: DeclarationManager,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("declaration.write"),
                        checkOfferPermission("isAllowedToTaxDeclaration"),
                    ],
                },
                {
                    path: "declaration2/:id",
                    name: "declaration2",
                    component: DeclarationManager,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("declaration.read"),
                        checkOfferPermission("isAllowedToTaxDeclaration"),
                    ],
                },
                {
                    path: "bundleSheet/:id",
                    name: "bundleSheet",
                    component: TaxFormReadOnly,
                    props: true,
                    beforeEnter: [
                        checkProfilePermission("declaration.read"),
                        checkOfferPermission("isAllowedToTaxDeclaration"),
                    ],
                },
                {
                    path: ":companyId/tasks",
                    name: "tasks",
                    component: Tasks,
                    props: true,
                    beforeEnter: checkProfilePermission("task.read"),
                },
                {
                    path: "/chats",
                    name: "chat",
                    component: ChatCompany,
                    props: true,
                    beforeEnter: checkProfilePermission("chat.read"),
                },
                {
                    path: "accountingClients/:mode",
                    name: "accountingClients",
                    component: AccountingClients,
                    props: true,
                },
                // { path: 'importMapping', name: 'importMapping', component: ImportMapping },
                { path: ":companyId/loan/new", name: "loan", component: DocumentLoan, props: true },
                {
                    path: ":companyId/loan/:id",
                    name: "loanId",
                    component: DocumentLoan,
                    props: true,
                    beforeEnter: checkProfilePermission("document.read"),
                },
                {
                    path: ":companyId/leasing/new",
                    name: "leasing",
                    component: DocumentLeasing,
                    props: true,
                    beforeEnter: checkProfilePermission("document.write"),
                },
                {
                    path: ":companyId/leasing/:id",
                    name: "leasingId",
                    component: DocumentLeasing,
                    props: true,
                    beforeEnter: checkProfilePermission("document.read"),
                },
                {
                    path: "wording-analysis-client-side",
                    name: "wording-analysis-client-side",
                    component: WordingAnalysisTable,
                },
                {
                    path: "wording-analysis-edition-client-side",
                    name: "wording-analysis-edition-client-side-new",
                    component: WordingAnalysisEdition,
                    props: function (route) {
                        if (route.query) {
                            return route.query;
                        } else return;
                    },
                },
                {
                    path: "wording-analysis-edition-client-side/:id",
                    name: "wording-analysis-edition-client-side",
                    component: WordingAnalysisEdition,
                    props: true,
                },
                {
                    path: "document-rules-client-side",
                    name: "document-rules-client-side",
                    component: DocumentRuleTable,
                },
                {
                    path: "document-rule-sheet-client-side/new",
                    name: "new-document-rule-sheet-client-side",
                    component: DocumentRuleSheet,
                    props: function (route) {
                        if (route.query) {
                            return route.query;
                        } else return;
                    },
                },
                {
                    path: "document-rule-sheet-client-side/:id",
                    name: "document-rule-sheet-client-side",
                    component: DocumentRuleSheet,
                    props: true,
                },
            ],
        },
        { path: "/:catch-all(.*)", component: PageNotFound },
        { path: "/403", name: "403", component: NoAccessPage },
    ],
});

router.beforeEach(
    async (
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
        next: (to?: false | RouteLocationRaw | undefined) => void,
    ) => {
        const start = Start.getCreateStart(to);
        console.log("beforeRouterEach");
        if (to.name === "loading-page") {
            return next();
        }

        if (PUBLICS_PAGES.some((page) => to.fullPath.startsWith(page))) {
            return next();
        }

        // if (to.fullPath.startsWith("/maintenance")) {
        //     console.log("maintenance");
        //     return next();
        // }
        // if (to.fullPath.startsWith("/login")) {
        //     console.log("login");
        //     // start = undefined;
        //     return next();
        // }
        // if (to.fullPath.startsWith("/register")) {
        //     console.log("register");
        //     // start = undefined;
        //     return next();
        // }
        // if (to.fullPath.startsWith("/public")) {
        //     console.log("public");
        //     // start = undefined;
        //     return next();
        // }
        // if (to.fullPath.startsWith("/password-recovery")) {
        //     console.log("pxd");
        //     return next();
        // }
        // if (to.fullPath.startsWith("/admin/login")) {
        //     console.log("admin log");
        //     // return next({ name: 'admin-login' })
        //     return next();
        // }
        // if (to.fullPath.startsWith("/auth-google-consent")) {
        //     return next();
        // }

        // if (to.fullPath.startsWith("/first-connexion")) {
        //     return next();
        // }
        // if (to.fullPath.startsWith("/tax-forms/playground")) {
        //     // return next({ name: 'signup' })
        //     return next();
        // }

        if (to.fullPath.startsWith("/")) {
            try {
                // console.log("Router 2");
                // console.log("from", from);
                // console.log("to", to);

                // debugger;

                if (!from.name) {
                    if (to?.params?.companyId) {
                        setCurrentCompany(apolloClient, store, {
                            id: to.params.companyId as string,
                        });
                    }
                }
                if (!start.loggedInUser) {
                    console.log("!start");
                    const userHomePage = await start.login();
                    // if (!to.path || to.path === "/") {
                    // console.log("!start 1")
                    if (!start.loggedInUser) {
                        return next({ name: "login", query: { from: userHomePage.fullPath } });
                    }
                    // }
                    // console.log("!start 2")
                    // return next({ name: "loading-page", query: { from: to.path } });
                } else if (!start.started) {
                    console.log("!start.started", to);
                    return next({ name: "loading-page", query: { from: to.path } });
                }
                const routerUser = store.state.user || start.loggedInUser;

                console.log("Router 3");
                if (!routerUser || !routerUser.id) {
                    console.log("Router 4", to);
                    return next({ name: "login", query: { from: to.path } });
                    // return next({ name: 'login' })
                }

                if (to.fullPath.startsWith("/admin")) {
                    store.commit("setInternalManagement", true);
                } else {
                    store.commit("setInternalManagement", false);
                }

                const user: User = await updateStoreUserAndSubUser(apolloClient, store, routerUser);
                // debugger
                // help
                if (
                    !store.state.firstHelpDone &&
                    user &&
                    user.lastAppVersion !== store.state.version
                ) {
                    // if (user.profile.help) {
                    store.commit("updateActivateHelp", true);
                    store.commit("updateFirstHelpDone", true);
                    // }
                    try {
                        apolloClient.mutate({
                            mutation: UPDATE_USER,
                            variables: {
                                id: routerUser.id,
                                appVersion: store.state.version,
                            },
                        });
                        user.lastAppVersion = store.state.version;
                    } catch (e) {
                        console.error(e);
                    }
                }

                if (
                    to.fullPath.startsWith("/admin") &&
                    !user.profile?.configuration?.internalManagement?.access
                ) {
                    return next({ name: "home", query: { from: to.path } });
                }

                if (to.fullPath.indexOf("toBeDone") === -1) {
                    store.commit("updateToBeDoneStatus", false);
                } else {
                    store.commit("updateToBeDoneStatus", true);
                }

                return next();
            } catch (e) {
                console.log("Router 5", e);
                // localStorage.removeItem('apollo-token')
                return next({ name: "login", query: { from: to.path } });
            }
        }
        return next();
    },
);
